import { IconType } from 'Shared/atoms/Icon'

export const DEFAULT_NO_DATA_PARAMS = {
	title: undefined,
	iconType: 'noData' as IconType
}
